import {
  BookOpen,
  Building,
  ChartLine,
  Graph,
  Heart,
  MessageFrown,
  MessageHeart,
  SearchPerson,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import type { SidebarManifest } from 'modules/core/lib/manifests/types'

export const sidebarManifest: SidebarManifest = (navigation) => {
  return [
    // Personal group
    {
      identifier: 'my_trainings',
      name: i18n.t('sidebar.my_trainings'),
      path: navigation.myTrainings.revamp.overview.fullPath(),
      factorialOneIcon: BookOpen,
      group: 'personal',
      module: 'my_trainings',
      priority: 'medium',
    },
    {
      identifier: 'kudos',
      name: 'Kudos',
      factorialOneIcon: Heart,
      path: navigation.kudos.fullPath(),
      group: 'personal',
      module: 'kudos',
      priority: 'lowest',
    },
    // Company group
    {
      identifier: 'spaces',
      name: i18n.t('sidebar.space_control'),
      factorialOneIcon: Building,
      path: navigation.spaceControl.fullPath(),
      group: 'company',
      module: 'space_control',
      priority: 'lowest',
    },
    // Talent group
    {
      identifier: 'performance',
      name: i18n.t('sidebar.performance_new'),
      factorialOneIcon: Graph,
      path: navigation.performanceProcess.fullPath(),
      group: 'talent',
      module: 'performance',
      priority: 'high',
    },
    {
      identifier: 'recruitment',
      name: i18n.t('sidebar.recruitment'),
      factorialOneIcon: SearchPerson,
      path: navigation.ats.fullPath(),
      group: 'talent',
      module: 'recruitment',
      priority: 'high',
    },
    {
      identifier: 'engagement',
      name: i18n.t('sidebar.engagement'),
      factorialOneIcon: MessageHeart,
      path: navigation.engagement.fullPath(),
      group: 'talent',
      module: 'engagement_insights',
      priority: 'medium',
    },
    {
      identifier: 'training',
      name: i18n.t('sidebar.trainings'),
      factorialOneIcon: BookOpen,
      path: navigation.trainings.fullPath(),
      group: 'talent',
      module: 'company_trainings',
      priority: 'medium',
    },
    {
      identifier: 'talent_analytics',
      name: i18n.t('sidebar.talent_analytics'),
      factorialOneIcon: ChartLine,
      path: navigation.talentAnalytics.fullPath(),
      group: 'talent',
      module: 'talent_analytics',
      priority: 'highest',
    },
    // More group
    {
      identifier: 'complaints',
      name: i18n.t('sidebar.complaints'),
      factorialOneIcon: MessageFrown,
      path: navigation.complaints.fullPath(),
      group: 'more',
      module: 'complaints',
      priority: 'low',
    },
  ]
}
